"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getURLParam = exports.getHashValue = exports.getQuery = void 0;
var getSearch = function (url) {
    if (typeof url === 'string') {
        return url;
    }
    return url.search;
};
/**
 * 获取url的query参数
 * @param key query参数
 * @param url (可选)url地址链接
 */
exports.getQuery = function (key, url) {
    var location = url || global.location || '';
    var queryRes = getSearch(location).match(new RegExp("(\\?|&)" + key + "=([^&]*)(#|&|$)"));
    return !queryRes ? '' : decodeURIComponent(queryRes[2]);
};
var getHash = function (url) { return url.hash || ''; };
/**
 * 获取url的hash参数
 * @param key hash参数
 */
exports.getHashValue = function (key) {
    var location = global.location || '';
    var match = getHash(location).match(new RegExp("(#|&)" + key + "=([^&]*)(#|&|$)"));
    return !match ? '' : decodeURIComponent(match[2]);
};
/**
 * 获取url的hash参数
 * @param key hash 或者 query 参数
 */
// 获取 url 的 hash 或者 query 参数
exports.getURLParam = function (key) { return exports.getHashValue(key) || exports.getQuery(key); };
